// MUI Switch в синем цвете Контроля (palette.blue.main). Вынесен из
// настроек динамических ключей: тот же переключатель стоит у заголовка
// главной (тоггл «Новая главная», business_apps#1486).

import styled from 'styled-components'
import { Switch } from '@material-ui/core'

export const BlueSwitch = styled(Switch)`
  && .MuiSwitch-switchBase.Mui-checked {
    color: ${(p) => p.theme.palette.blue.main};
  }
  && .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${(p) => p.theme.palette.blue.main};
    opacity: 1;
  }
  && .MuiSwitch-track {
    opacity: 1;
  }
`

export default BlueSwitch
